import TagSwitcher from "./TagSwitcher";
// legacy file to keep old imports working
export default TagSwitcher;
